import React, { forwardRef, useState, useMemo } from 'react';
import { Text, View, Pressable } from 'react-native';
import * as Animatable from 'react-native-animatable';
import { Title } from '@constants/Themed';


const FlowTypeComponent = ({ type, open }) => {


  const renderComponent = () => {
    switch (type) {
      case 'email':
        return <Text>Text</Text>;
      case 'project':
        return (
          <View style={{ flex: 1, padding: 15, gap: 20 }}>
            <Title style={{ color: 'white', fontSize: 32 }}>Project Example</Title>
            <Text style={{ fontSize: 24, color: "white" }}>Select a project template to automate project creation upon submission of data</Text>
            <View style={{ flex: 1 }}>

            </View>
          </View>
        );
      case 'calendar':
        return <Text>Text</Text>;
      case 'document':
        return <Text>Text</Text>;
      case 'integration':
        return <Text>Text</Text>;
      default:
        return <Text>Default</Text>;
    }
  }

  return useMemo(() => (
    <View style={{ flex: 1, position: 'absolute' }}>
      {
        open && <Animatable.View transition={'minHeight'} style={{ minHeight: open ? 500 : 140, minWidth: open ? 150 : 500 }}>
          {renderComponent()}
        </Animatable.View>
      }
    </View >
  ), [open, type])
}
export default FlowTypeComponent;